module.exports = "<p>small-card works!</p>\n"